/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiAdminsIdMutationResponse, DeleteApiAdminsIdPathParams, DeleteApiAdminsId400, DeleteApiAdminsId401, DeleteApiAdminsId403, DeleteApiAdminsId404, DeleteApiAdminsId500 } from "../../types/DeleteApiAdminsId.ts";
import { deleteApiAdminsIdMutationResponseSchema } from "../../zod/SuperAdminSchemas/deleteApiAdminsIdSchema.ts";

function getDeleteApiAdminsIdUrl({ id }: { id: DeleteApiAdminsIdPathParams["Id"] }) {
  const res = { method: 'DELETE', url: `/api/admins/${id}` as const }  
  return res
}

/**
 * @summary Удаление администратора (Доступно только для суперадмина)
 * {@link /api/admins/:Id}
 */
export async function deleteApiAdminsId({ id }: { id: DeleteApiAdminsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiAdminsIdMutationResponse, ResponseErrorConfig<DeleteApiAdminsId400 | DeleteApiAdminsId401 | DeleteApiAdminsId403 | DeleteApiAdminsId404 | DeleteApiAdminsId500>, unknown>({ method : "DELETE", url : getDeleteApiAdminsIdUrl({ id }).url.toString(), ... requestConfig })  
  return deleteApiAdminsIdMutationResponseSchema.parse(res.data)
}